import React, { useEffect } from "react";
import { Redirect, Switch } from "react-router-dom";
import SimpleRoute from "./../../modules/routes/SimpleRoute";
import PrivateRoute from "./../../modules/routes/PrivateRoute";
import authSelectors from "./../../modules/auth/authSelectors";
import Upload from "../../containers/Upload/index.tsx";
import BlogPost from "../../containers/Blog";
import Login from "../../containers/Auth/Login";
import Signup from "../../containers/Auth/Signup/";
import { useSelector } from "react-redux";
import ProgressBar from "../Shared/ProgressBar";
import Processing from "./../../containers/Processing/index";
import PaywallPopup from "../Paywall Popup/PaywallPopup";
import SuccessPage from "../Paywall Popup/SuccessPage/SuccessPage";

function RoutesComponent(props) {

  const currentUser = useSelector(authSelectors.selectCurrentUser);
  const authLoading = useSelector(authSelectors.selectLoading);

  useEffect(() => {
    //ProgressBar.start();

    if (!authLoading) {
      ProgressBar.done();
    } else {
      ProgressBar.start();
    }
  }, [authLoading]);
  if (authLoading) return <div />;

  return (
    <Switch>
      <Redirect exact from="/" to="/upload1" />
      <SimpleRoute
        exact
        path="/login"
        key={"login"}
        currentUser={currentUser}
        component={(props) => <Login {...props} />}
      />
      <SimpleRoute
        exact
        path="/signup"
        key={"/signup"}
        currentUser={currentUser}
        component={(props) => <Signup {...props} />}
      />
      <PrivateRoute
        exact
        path="/upload1"
        key={"/upload1"}
        currentUser={currentUser}
        component={(props) => <Upload {...props} />}
      />
      <PrivateRoute
        exact
        path="/processing/:id"
        key={"/processing"}
        currentUser={currentUser}
        component={(props) => <Processing {...props} />}
      />
      <PrivateRoute
        exact
        path="/upload2"
        key={"/upload2"}
        currentUser={currentUser}
        component={(props) => <Upload {...props} />}
      />
      <PrivateRoute
        exact
        path="/blog/:id"
        key={"/blog"}
        currentUser={currentUser}
        component={(props) => <BlogPost {...props} />}
      />
      <PrivateRoute
        exact
        path="/success/:id"
        key={"/success"}
        currentUser={currentUser}
        component={(props) => <SuccessPage {...props} />}
      />
    </Switch>
  );
}

export default RoutesComponent;
